import React, {useEffect, useState} from 'react';
import AsyncSelect from 'react-select/async';
import axios from 'axios';

const fetchContacts = async (inputValue, vendor) => {
	if (!inputValue) {
		return [];
	}

	const response = await axios.post(`${process.env.REACT_APP_HOST_URL}/contact/search/input`, {
		vendor,
		search: inputValue
	});

	const contacts = response.data.data;

	return contacts.map(contact => ({
		label: contact.name,
		value: contact.id
	}));
};

const ContactSelect = props => {
	const { value, vendor, disabled, onChange, reset } = props;
	const [selectedContact, setSelectedContact] = useState(value);

	useEffect(() => {
		const load = async () => {
			setSelectedContact(value);
		};
		load();
	}, [value]);

	useEffect(() => {
		const load = async () => {
			loadOptions('-999');
		};
		load();
	}, [reset]);

	const handleChange = (selectedOption) => {
		setSelectedContact(selectedOption);
		onChange(selectedOption);
	};

	const loadOptions = (inputValue) => {
		if(vendor && vendor !== '-1' && inputValue && inputValue.length > 1) {
			return fetchContacts(inputValue, vendor); // Specify the limit here
		}
		return [];
	};

	return (
		<div style={{width: '90%'}}>
			<AsyncSelect
				placeholder="Enter at least 2 characters to search."
				isDisabled={disabled}
				cacheOptions={false}
				loadOptions={loadOptions}
				defaultOptions={!disabled}
				onChange={handleChange}
				value={selectedContact}
				styles={{
					control: (baseStyles, state) => ({
						...baseStyles,
						backgroundColor: state.isDisabled ? '#F5F9FF' : baseStyles.backgroundColor,
						borderColor: '#D3E1ED',
					}),
					placeholder: (baseStyles, state) => ({
						...baseStyles,
						color: state.isDisabled ? '#B6C3CF' : baseStyles.color,
					}),
					dropdownIndicator: (baseStyles, state) => ({
						...baseStyles,
						color: '#6A8991',
						width: 34,
						height: 34,
					}),
				}}
			/>
		</div>
	);
};

export default ContactSelect;
